import { Bar } from '@nivo/bar';
import { Loading } from 'e4shared';
import { useTextMeasurer } from 'helpers/dom';
import React from 'react';

export const ScoreDifferential = ({ data, consts, divHeight }) => {
    const [mappedData, setMappedData] = React.useState([]);
    const [width, setWidth] = React.useState(0);

    const truncate = useTextMeasurer('12px sans-serif');

    React.useEffect(() => {
        const temp = data.map(d => ({ location: d.x, value: (d.z - d.y).toFixed(1) }));
        setMappedData(temp.sort((a, b) => (a.location > b.location ? -1 : 1)));
    }, [data]);

    React.useEffect(() => {
        if (data?.length) {
            const parent = document.getElementById(consts.parent);
            setWidth(parent.offsetWidth);
        }
    }, [data]);

    if (!width) {
        return <Loading />;
    }

    return (
        <div style={data.length > 10 ? { height: `${divHeight(mappedData)}px`, overflowY: 'auto' } : null}>
            <Bar
                data={mappedData}
                indexBy="location"
                keys={['value']}
                colors={['#004D6B']}
                borderRadius={4}
                layout="horizontal"
                enableGridX={true}
                gridXValues={[-4, -2, 0, 2, 4]}
                enableGridY={false}
                padding={consts.padding}
                height={divHeight(mappedData, true)}
                width={width - consts.leftMargin}
                margin={{ top: 0, right: 30, bottom: consts.axisHeight, left: consts.leftMargin }}
                valueScale={{
                    type: 'linear',
                    min: -4.4,
                    max: 4,
                    clamp: true, // Prevents bars from overflowing
                }}
                axisBottom={{
                    tickValues: [-4, -2, 0, 2, 4],
                    tickSize: 0,
                    tickPadding: 5,
                    tickRotation: 0,
                }}
                axisLeft={{
                    renderTick: tick => (
                        <g dominantBaseline="central" transform={`translate(${tick.x},${tick.y})`}>
                            <text
                                transform={`translate(-${consts.leftMargin}, 0)`}
                                textAnchor="left" // Ensures left-aligned text
                                style={{
                                    color: '#333',
                                    fontSize: 11,
                                }}
                            >
                                {truncate(tick.value, consts.leftMargin - 5)}
                            </text>
                        </g>
                    ),
                }}
                enableLabel={false} // disable default labels
                layers={[
                    'grid',
                    'axes',
                    'bars',
                    'markers',
                    'legends',
                    'annotations',
                    props => {
                        // custom label layer
                        return props.bars.map(bar => (
                            <text
                                key={bar.key}
                                x={bar.data.data.value > 0 ? bar.x + bar.width + 5 : bar.x - 25} // place text 30px before bar end
                                y={bar.y + bar.height / 2 + 1}
                                textAnchor="start"
                                alignmentBaseline="middle"
                                style={{
                                    fill: '#333',
                                    fontSize: 11,
                                    fontWeight: 600,
                                }}
                            >
                                {bar.data.value > 0 ? `+${bar.data.value}` : bar.data.value < 0 ? `${bar.data.value}` : null}
                            </text>
                        ));
                    },
                ]}
                tooltip={({ id, value, color, indexValue }) => (
                    <span>{`${indexValue}: ${value > 0 ? `+${value}` : value < 0 ? `${value}` : 0}`}</span>
                )}
            />
        </div>
    );
};

export default ScoreDifferential;
